import React, { useContext } from 'react'
import BannerComponent from 'components/Banner'

import bannerContext from './bannerContext'

const Banner = () => {
  const { items, dismissBanner } = useContext(bannerContext)

  return (
    <>
      {items.map(({ message, type, id, dismissible }) => (
        <BannerComponent
          type={type}
          key={id}
          dismissible={dismissible}
          onDismiss={() => {
            dismissBanner(id)
          }}>
          {message}
        </BannerComponent>
      ))}
    </>
  )
}

export default Banner
